import {Component} from '@angular/core'

interface CustomerStoryGroup {
  groupName: string,
  customerStories: CustomerStory[]
}

export interface CustomerStory {
  id: number
  name: string
  link: string
  img: string
  excerpt: string
}

@Component({
  selector: 'app-customer-stories-modal',
  templateUrl: 'customer-stories-modal.component.html',
  styleUrls: ['customer-stories-modal.component.scss'],
})
export class CustomerStoriesModalComponent {

  customerStoryGroups: CustomerStoryGroup[] = [
    {
      groupName: 'Road Events',
      customerStories: [
        {
          id: 1,
          name: 'OnePlan for World Triathlon',
          link: '',
          img: 'https://picsum.photos/500/300?random=6',
          excerpt: 'Read how World Triathlon have partnered with OnePlan to create a customised ‘OnePlan for Triathlons’ platform, to manage their 28 international events - available for all triathlons worldwide.'
        },
        {
          id: 2,
          name: 'OnePlan for World Triathlon',
          link: '',
          img: 'https://picsum.photos/500/300?random=5',
          excerpt: 'Read how World Triathlon have partnered with OnePlan to create a customised ‘OnePlan for Triathlons’ platform, to manage their 28 international events - available for all triathlons worldwide.'
        },
      ]
    },
    {
      groupName: 'More Events',
      customerStories: [
        {
          id: 3,
          name: 'OnePlan for World Triathlon',
          link: '',
          img: 'https://picsum.photos/500/300?random=4',
          excerpt: 'Read how World Triathlon have partnered with OnePlan to create a customised ‘OnePlan for Triathlons’ platform, to manage their 28 international events - available for all triathlons worldwide.'
        },
        {
          id: 4,
          name: 'OnePlan for World Triathlon',
          link: '',
          img: 'https://picsum.photos/500/300?random=3',
          excerpt: 'Read how World Triathlon have partnered with OnePlan to create a customised ‘OnePlan for Triathlons’ platform, to manage their 28 international events - available for all triathlons worldwide.'
        },
        {
          id: 5,
          name: 'OnePlan for World Triathlon',
          link: '',
          img: 'https://picsum.photos/500/300?random=2',
          excerpt: 'Read how World Triathlon have partnered with OnePlan to create a customised ‘OnePlan for Triathlons’ platform, to manage their 28 international events - available for all triathlons worldwide.'
        },
        {
          id: 6,
          name: 'OnePlan for World Triathlon',
          link: '',
          img: 'https://picsum.photos/500/300?random=1',
          excerpt: 'Read how World Triathlon have partnered with OnePlan to create a customised ‘OnePlan for Triathlons’ platform, to manage their 28 international events - available for all triathlons worldwide.'
        },
      ]
    },
  ]
}
